import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { PencilIcon } from "lucide-react";
import { useEffect, useState } from "react";
import GymTimingsForm from "../../modal/my-business/gym-timing-form";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { formatTo12Hour } from "@/lib/helper";
import { useEditor } from "@tiptap/react";
import { SystemSettings } from "@/types/system-setting/system-config";
interface GymTimingsProps {
  setting?: Record<string, string | BusinessHours>,
  title: string,
  refetch: () => void
}

interface BusinessHours {
  opening_time: string;
  closing_time: string;
}

interface BusinessHoursRecord {
  [key: string]: BusinessHours;
}

export default function GymTimings({ setting, title, refetch }: GymTimingsProps) {
  const dayOrder: { [key: string]: number } = {
    sunday: 1,
    monday: 2,
    tuesday: 3,
    wednesday: 4,
    thursday: 5,
    friday: 6,
    saturday: 7,
  };

  const [isOpen, setOpen] = useState(false);
  const [action, setAction] = useState<"add" | "edit">("add");
  const [data, setData] = useState<Record<string, string | BusinessHours> | undefined>(setting);
  const [businessHours, setBusinessHours] = useState<BusinessHoursRecord>({});

  useEffect(() => {
    if (setting) {
      const parsedHours = Object.entries(setting).reduce((acc, [day, hoursData]) => {
        console.log({setting})
        try {
          // Check if hoursData is already an object or a string
          let hours: BusinessHours;
          if (typeof hoursData === 'string') {
            // Handle Python-style dictionary strings (with single quotes)
            // Convert Python dict format to JSON format
            const jsonString = hoursData
              .replace(/'/g, '"')  // Replace single quotes with double quotes
              .replace(/True/g, 'true')  // Replace Python boolean
              .replace(/False/g, 'false'); // Replace Python boolean
            
            hours = JSON.parse(jsonString) as BusinessHours;
          } else {
            hours = hoursData as BusinessHours;
          }
          acc[day] = hours;
        } catch (e) {
          console.warn(`Failed to parse hours for ${day}:`, e);
          // Provide fallback empty hours if parsing fails
          acc[day] = { opening_time: '00:00', closing_time: '00:00' };
        }
        return acc;
      }, {} as BusinessHoursRecord);

      setBusinessHours(parsedHours);
      setData(setting);
    }
  }, [setting, refetch]);

  const handleEdit = () => {
    setAction("edit");
    setOpen(true);
    // Add your edit logic here
  };

  const sortedBusinessHours = Object.entries(businessHours)
    .sort(([dayA], [dayB]) => (dayOrder[dayA] || 0) - (dayOrder[dayB] || 0));

  return (
    <Card className="w-full ">
      <CardHeader className="flex flex-row items-center justify-between px-6 py-2">
        <CardTitle>Gym Timing:</CardTitle>
        <Button
          size="icon"
          variant="ghost"
          className="rounded-lg bg-primary p-2 shadow-sm hover:bg-primary/90 h-8 w-8"
          onClick={() => handleEdit()}

        >
          <PencilIcon className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Day</TableHead>
              <TableHead>Opening Time</TableHead>
              <TableHead>Closing Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedBusinessHours.map(([day, hours]) => (
              <TableRow key={day}>
                <TableCell className="font-medium capitalize">{day}</TableCell>
                <TableCell>{formatTo12Hour(hours.opening_time)}</TableCell>
                <TableCell>{formatTo12Hour(hours.closing_time)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <GymTimingsForm
        editModeData={data}
        isOpen={isOpen}
        setOpen={setOpen}
        action={action}
        setAction={setAction}
        refetch={refetch}
      />
    </Card>
  );
}
